import React from 'react';
import Select from "react-select";

export const ModuleSelector = (props) => {

    const moduleOptions = props.modules.map((module) => {
        return {value: module.name, label: module.name}
    });

    const selectedModule = moduleOptions.find((option) => option.label === props.selectedModule);

    return (
        <div className="row">
            <div className="col-lg-6" style={{zIndex: '1000'}}>
                <label>Modul</label>
                <Select name="status"
                        placeholder="Bitte wählen"
                        value={selectedModule}
                        onChange={(value) => props.selectModule(value.label)}
                        options={moduleOptions}
                />
            </div>
            <div className="col-lg-6">
            </div>
        </div>
    )

};

export default ModuleSelector;


// WEBPACK FOOTER //
// ./src/admin/components/ModuleSelector.js